/* tslint:disable */
/* eslint-disable */
/**
 * Commerce List App Service
 * This is to provide all the list related operations at data tier.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: shikha.raghava@amway.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const ExceptionDetail = {
  ConnectionRefused: 'CONNECTION_REFUSED',
  ListIdMissing: 'LIST_ID_MISSING',
  ListNotFound: 'LIST_NOT_FOUND',
  ListMaxLimitExceeded: 'LIST_MAX_LIMIT_EXCEEDED',
  WrongListId: 'WRONG_LIST_ID',
  PrivateListType: 'PRIVATE_LIST_TYPE',
  IncorrectVersionId: 'INCORRECT_VERSION_ID',
  EmptyListEntries: 'EMPTY_LIST_ENTRIES',
  ListCountMissingInMasterData: 'LIST_COUNT_MISSING_IN_MASTER_DATA',
  NonAboUserNotAllowedToUpdate: 'NON_ABO_USER_NOT_ALLOWED_TO_UPDATE',
  NonAboUserNotAllowedToCreate: 'NON_ABO_USER_NOT_ALLOWED_TO_CREATE',
  IdempotencyMissingInHeader: 'IDEMPOTENCY_MISSING_IN_HEADER',
  DatabaseException: 'DATABASE_EXCEPTION',
} as const;
export type ExceptionDetail = (typeof ExceptionDetail)[keyof typeof ExceptionDetail];

export function ExceptionDetailFromJSON(json: any): ExceptionDetail {
  return ExceptionDetailFromJSONTyped(json, false);
}

export function ExceptionDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExceptionDetail {
  return json as ExceptionDetail;
}

export function ExceptionDetailToJSON(value?: ExceptionDetail | null): any {
  return value as any;
}
